// extracted by mini-css-extract-plugin
module.exports = {"marginAuto":"Container_marginAuto__ZnygQ","flex":"Container_flex__61vcR"};